import React, { useState } from 'react'
import { Autocomplete, Box, Button, Chip, Dialog, DialogTitle, DialogContent, IconButton, TextField, Typography, Modal } from '@mui/material';
import { styled } from '@mui/material/styles';
import InsertLinkRoundedIcon from '@mui/icons-material/InsertLinkRounded';
import { saveAs } from 'file-saver';
import { ReactComponent as Download } from "../../../Assets/img/icons/Download-share.svg"
import CloseIcon from "@mui/icons-material/Close";
import facebook from '../../../Assets/img/icons/Facebook.svg'
import whatsapp from '../../../Assets/img/icons/whatsapp.svg'
import insta from '../../../Assets/img/icons/instagram.svg'
import linkedin from '../../../Assets/img/icons/linkedin.svg'
import signal from '../../../Assets/img/icons/signal.svg'
import telegram from '../../../Assets/img/icons/Telegram.svg'
import QrCodeCard from "./QrCodeCard";
import { ReactComponent as TickIcon } from "../../../Assets/img/icons/tick-shape.svg";
import { useUserDetailContext } from '../../UserDetailContext';
import { ToastContainer, toast } from "react-toastify";
import { useQuantityContext } from '../../QuantityContext';

const ShareQR = ({ cardType, sharePopover, onClose }) => {

  const apiKey = process.env.REACT_APP_API_KEY
  const headers = {
    'x-api-key': apiKey,
    'Content-Type': 'application/json'
  };

  const [emails, setEmails] = useState([]);
  const [emailInput, setEmailInput] = useState('');
  const [emailError, setEmailError] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);

  const { userDetails } = useUserDetailContext();
  const { openSnackbar } = useQuantityContext();
  const objectId = localStorage.getItem("objectId");

  let phoneNo = userDetails?.phoneNo || "";
  phoneNo = phoneNo.replace(/\s+/g, "");

  const url = `${process.env.REACT_APP_CARD_URL}/digital-identity/${cardType}/${objectId}`;
  const message = url;
  const encodedMessage = encodeURIComponent(message);
  const whatsappLink = `https://api.whatsapp.com/send?phone=${phoneNo}&text=${encodedMessage}`;
  const telegramLink = `https://t.me/${phoneNo}?text=${encodedMessage}`;

  const encodedUrl = encodeURIComponent(`https://app.neoin.co/digital-identity/${cardType}/${objectId}`);
  const linkedinPostLink = `https://www.linkedin.com/shareArticle?mini=true&url=${encodedUrl}`;

  const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
      padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
      padding: theme.spacing(1),
    },
  }));

  const handleDownload = async () => {
    const canvas = document.querySelector('canvas');
    const blob = await canvasToImage(canvas, 'image/png'); // Change to 'image/jpeg' for JPEG format
    saveAs(blob, 'qrcode.png'); // Change file name and extension accordingly
  };

  const canvasToImage = (canvas, type) => {
    return new Promise((resolve) => {
      canvas.toBlob((blob) => {
        resolve(blob);
      }, type);
    });
  };

  const copyToClipboard = (item, handleSuccess, handleFailure) => {
    navigator.clipboard.writeText(item).then(() => {
      handleSuccess('Link Copied!');
    }).catch((err) => {
      handleFailure('Could not Copy Link.')
      console.error("Failed to copy: ", err);
    });
  }

  const handleAddEmail = (event) => {
    if ((event.key === 'Enter' || event.key === ',' || event.key === ' ') && emailInput && emailInput.trim()) {
      const email = emailInput.trim();
      if (/\S+@\S+\.\S+/.test(email) && !email.includes(' ')) {
        setEmails((prevEmails) => [...prevEmails, email]);
        setEmailInput('');
        setEmailError(false);
        setIsDisabled(false);
      } else {
        setEmailError(true);
      }
      event.preventDefault();
    }
  };

  const handleDeleteEmail = (emailToDelete) => () => {
    setEmails((prevEmails) => prevEmails.filter(email => email !== emailToDelete));
  };

  const handleInputChange = (event, newInputValue) => {
    setEmailInput(newInputValue);
  };

  const handleAutocompleteChange = (event, newValue) => {
    setEmails(newValue);
  };

  const handleSend = async (event) => {
    event.preventDefault(); // Prevent default form submission
    if (emails.length === 0) {
      handleFailure();
    } else {
      // console.log("mail list:",emails);
      try {
        const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/mail/send-email-qrlink`, {
          method: 'POST',
          headers: headers,
          body: JSON.stringify({ emails, url, message: `Here's a link to my ${cardType} card:`, name: '', cardType: `${cardType} Card`, objectId: objectId })
        });
        if (response.ok) {
          setIsDisabled(true);
          handleSuccess();
          setEmails([]);
          setEmailError('');
        } else {
          throw new Error('Failed to send email');
        }
      } catch (error) {
        console.error('Error sending email:', error.message);
        handleFailure('Failed to send email');
      }
    }
  };

  const handleSuccess = (message = "Sent Successfully!") => {
    openSnackbar(message, "success");
  };

  const handleFailure = (message = "Failed to Send.") => {
    openSnackbar(message, "failure");
  };

  //   useEffect(() => {
  //     console.log('ShareQR re-rendered :(');
  // });

  return (
    <div className='share-qr-container'>
      <Modal
        onClose={() => onClose(cardType)}
        aria-labelledby="customized-dialog-title"
        open={sharePopover}
        className="share-dialog"
      >
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: "auto", bgcolor: 'background.paper', boxShadow: "0px 4px 4px 0px #00000040", borderRadius: 2, paddingTop: 2 }}>
          <IconButton
            aria-label="close"
            onClick={() => onClose(cardType)}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
          <Box
            dividers
            sx={{ m: 0, p: 2, width: 500 }}
          >
            <Box gutterBottom sx={{ m: 0, p: 0, }}>
              <div className="text-center">
                <a
                  href={`${process.env.REACT_APP_CARD_URL}/digital-identity/${cardType}/${objectId}`}
                  rel="noopener noreferrer"
                  target='_blank'
                  className='d-flex flex-column justify-content-center align-items-center'
                >
                  {/* <div>
                  <div ref={qrCodeRef}></div>
                </div> */}
                  <div>
                    <QrCodeCard CARDNAME_id={cardType} />
                  </div>

                </a>
              </div>
            </Box>
            <Box className="text-center downloadShareButtonNew my-3" gutterBottom>
              <button className="download-share-button mt-n1" onClick={handleDownload}>
                <Download className="dowload-share-icon" />
                Download QR Code
              </button>
            </Box>
            <div>
              <ToastContainer toastClassName="copy-link-success" />
              <ToastContainer toastClassName="copy-link-fail" />
            </div>
            <Box className="mt-3" gutterBottom>
              <div className="share-qr-content">
                Share with your friends
              </div>
              <div className="share-qr-subcontent text-left mt-2">
                Connect and Share with Friends
              </div>
            </Box>
            <Box gutterBottom>
              <div className="row mt-3">
                <div className="d-flex  justify-content-between">
                  {/* <a href="#facebook-link" target='_blank' rel='noreferrer'>
                    <img src={facebook} alt="facebook" className="share-icons mr-3" />
                  </a> */}
                  <a href={whatsappLink} target='_blank' rel='noreferrer'>
                    <img src={whatsapp} alt='whatsapp' className="share-icons mr-3" />
                  </a>
                  {/* <a href="#instagram-link" target='_blank' rel='noreferrer'>
                    <img src={insta} alt="instagram" className="share-icons mr-3" />
                  </a> */}
                  <a href={linkedinPostLink} target='_blank' rel='noreferrer'>
                    <img src={linkedin} alt="linkedin" className="share-icons mr-3" />
                  </a>
                  {/* <a href="#signal-link" target='_blank' rel='noreferrer'>
                    <img src={signal} alt="signal" className="share-icons mr-3" />
                  </a> */}
                  <a href={telegramLink} target='_blank' rel='noreferrer'>
                    <img src={telegram} alt='telegram' className="share-icons" />
                  </a>
                </div>
              </div>

            </Box>
            <div className='d-flex align-items-center mt-3 hovering_color_change pointer' onClick={() => copyToClipboard(url, handleSuccess, handleFailure)}>
              <InsertLinkRoundedIcon />
              <p className='p-0 m-0 ms-2 group_permissiions_options hover'>Copy Card Link</p>
            </div>
          </Box>
        </Box>
      </Modal>
    </div>
  )
};

export default ShareQR